import { create } from 'zustand';
import { apiFetch } from '../lib/api';

/**
 * [Logo do tenant — SUBBAR] Identidade do tenant logado (`nome_empresa` +
 * `logo_url`), carregada uma vez no boot da sessão via `GET
 * /minha-conta/empresa` (qualquer perfil do tenant — não só ADMIN_TENANT).
 * Mesmo padrão de `EstabelecimentosBoot`/`ModulosBoot` (App.tsx): fetch 1x
 * por login, `limpar()` no logout.
 *
 * `logo_url` pode ser uma presigned S3 (PROD/QA) com TTL — não é renovada a
 * cada navegação (o React Router não remonta os Boots em troca de rota
 * client-side), só quando este store é `recarregar()`ado de novo (próximo
 * login/boot). Mesmo compromisso já aceito no projeto para mídia de inbox
 * (AB#309/AB#349): uma vez que o `<img>` carregou a URL, o browser já tem os
 * bytes — só um reload/nova aba pede uma URL nova, e aí o boot já busca uma
 * fresca. Ver docblock de `Tenant.logo_key` no schema para a razão de a URL
 * nunca ser persistida.
 */

interface EmpresaIdentidadeState {
  nome_empresa: string;
  logo_url: string | null;
  carregado: boolean;
  recarregar: () => Promise<void>;
  limpar: () => void;
}

export const useEmpresaIdentidadeStore = create<EmpresaIdentidadeState>((set) => ({
  nome_empresa: '',
  logo_url: null,
  carregado: false,
  recarregar: async () => {
    try {
      const res = await apiFetch('/minha-conta/empresa');
      if (!res.ok) return;
      const data = (await res.json()) as { nome_empresa: string; logo_url: string | null };
      set({ nome_empresa: data.nome_empresa, logo_url: data.logo_url, carregado: true });
    } catch {
      // Backend fora — SUBBAR segue sem identidade (sem quebrar o shell).
    }
  },
  limpar: () => set({ nome_empresa: '', logo_url: null, carregado: false }),
}));
